import type { Foodstuff } from '../models/Foodstuff';
import { resolveFoodstuffWeightInGrams } from './mealMetrics';

export function buildConsumedMealFoodstuffs(foodstuffs?: Foodstuff[]): Foodstuff[] {
    return (foodstuffs || []).reduce<Foodstuff[]>((acc, foodstuff) => {
        if (!foodstuff.id) {
            return acc;
        }

        const weight = resolveFoodstuffWeightInGrams(foodstuff);
        if (!Number.isFinite(weight) || (weight as number) <= 0) {
            return acc;
        }

        acc.push({
            id: foodstuff.id,
            weight,
        });
        return acc;
    }, []);
}
